<template>
  <div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="module" class="mb-1"><b><u class="section-title"><i class="feather icon-layers"></i>&nbsp;&nbsp;Módulos&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></label>
        <input v-model="filter.module" type="text" class="form-control input_sm" name="module" placeholder="Buscar Módulo ó Código" @keyup.enter="getRecords(null)">
      </div>
      <div class="col-md-12">
        <button class="btn btn-sm btn-success btn-icon-split" title="Filtrar o buscar registro" @click="getRecords(null)"><i class="fas fa-filter"></i> Filtrar</button>
        <button class="btn btn-sm btn-danger btn-icon-split" title="Borrar filtro" @click="clearFilter()"><i class="fas fa-ban"></i></button>
      </div>
      <div class="col-12 text-right mt-1">
        <a :href="exportUrl()" class="btn btn-sm btn-info mt-1 mr-1" title="Descargar en Excel los registros del filtro aplicado"><i class="fas fa-file-excel"></i> Exportar</a>
        <button @click="create" class="btn btn-sm btn-warning mt-1 mr-1" title="Agregar registro"><i class="fas fa-plus"></i> Nuevo</button>
        <hr>
      </div>
    </div>

    <b-overlay :show="loading" rounded="sm">
      <div class="table-responsive tableBg">
        <table class="table table-striped table-bordered zero-configuration">
          <thead>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Código</th>
              <th>Curso</th>
              <th>Módulos</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in records" :key="index">
              <td>{{ record.index }}</td>
              <td>
                <button class="btn btn-sm btn-danger btn-icon-split btn-xs" @click="destroy(record.id, record.code)" title="Eliminar">
                  <span class="icon text-white">
                    <i class="fas fa-trash icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-info btn-icon-split btn-xs" title="Editar" @click="showForm(record.id)">
                  <span class="icon text-white">
                    <i class="fas fa-edit icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-warning btn-icon-split btn-xs" @click="changeStatus(record.id, record.code)" title="Cambiar Estado">
                  <span class="icon text-white">
                      <i class="fas fa-flag icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-success btn-icon-split btn-xs" @click="showRecord(record)" title="Ver">
                  <span class="icon text-white">
                    <i class="fas fa-eye icon_white"></i>
                  </span>
                </button>
              </td>
              <td>{{ record.code }}</td>
              <td>{{ record.coursename }}</td>
              <td>{{ record.module }}</td>
              <td>
                <div :class="{ 'badge badge-success': record.status === 1, 'badge badge-danger': record.status !== 1 }">
                    {{ record.status === 1 ? 'Activo' : 'Inactivo' }}
                </div>
              </td>
            </tr>
            <tr v-if="total == 0">
              <td colspan="5">No hay registros</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Código</th>
              <th>Curso</th>
              <th>Módulos</th>
              <th>Estado</th>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- Contenedor de paginación -->
      <div class="pagination-container d-flex justify-content-end">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" v-for="link in links" :class="{'disabled': link.url == null, 'active': link.active}">
              <a class="page-link" @click="getRecords(link.url)" v-html="link.label"></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="text-right">
        <span><i style="font-size: 14px; color: #7A7A7A">Cantidad de registros: {{total}}</i></span>
        <hr>
        <br>
      </div>
    </b-overlay>
    <modal-form :id="recordId" :showModal.sync="showModalForm" @getRecords="getRecords"></modal-form>
    <modal-status :code="recordCode" :id="recordId" :showModal.sync="showModalStatus" @getRecords="getRecords"></modal-status>
    <modal-destroy :code="recordCode" :id="recordId" :showModal.sync="showModalDestroy" @getRecords="getRecords"></modal-destroy>
    <modal-record :record="dataRecord" :showModal.sync="showModalRecord" @getRecords="getRecords"></modal-record>
  </div>
</template>

<script>
import ModalForm from './partials/ModalForm.vue'
import ModalStatus from './partials/ModalStatus.vue'
import ModalDestroy from './partials/ModalDestroy.vue'
import ModalRecord from './partials/ModalRecord.vue'
import { BOverlay } from 'bootstrap-vue'

export default {
  components: {ModalForm, BOverlay, ModalStatus, ModalDestroy, ModalRecord},
  data() {
    return {
      records: [],
      loading: false,
      filter: {},
      appliedFilter: {}, // filtro con el que se cargó la tabla; lo usa la exportación
      links: {},
      total: 0,
      recordId: null,
      recordCode: null,
      dataRecord: [],
      showModalForm: false,
      showModalStatus: false,
      showModalDestroy: false,
      showModalRecord: false
    }
  },
  created() {
    this.getRecords(null)
  },
  methods:{
    /**
     * URL de descarga en Excel con el filtro aplicado (no el que esté escrito sin filtrar).
     */
    exportUrl() {
      const params = new URLSearchParams();
      if (this.appliedFilter.module) params.append('module', this.appliedFilter.module);
      const query = params.toString();
      return '/administration/courses/modules/export' + (query ? '?' + query : '');
    },
    clearFilter(){
      this.filter = {};
      this.getRecords(null)
    },
    getRecords(url = null) {
      this.loading = true
      let page = 1
      if(url) {
        let param = new URL(url);
        page = param.searchParams.get("page");
      }
      this.appliedFilter = Object.assign({}, this.filter);

      axios.get(`/administration/courses/modules/records?page=${page}`, {params: this.filter})
        .then(response => {
          this.records = response.data.data.data
          this.links = response.data.data.links
          this.total = response.data.data.total
        })
        .catch((error)=>{
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showForm(id) {
      this.recordId = id
      this.showModalForm = true
    },
    create() {
      this.recordId = null
      this.showModalForm = true
    },
    changeStatus(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalStatus = true
    },
    destroy(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalDestroy = true
    },
    showRecord(record) {
      // this.recordId = id
      this.dataRecord = record
      this.showModalRecord = true
      // console.log(this.dataRecord)
    },
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 10px !important; /* Ajusta según sea necesario */
}
</style>